<template>
  <div id="say-hotels">
    <main v-if="!loading">
      <Header />
      <section v-if="loadError" class="max-w-screen-xl mx-auto px-4 py-20 text-center">
        <h1 class="font-secondary text-2xl md:text-3xl mb-4">{{ tr('Hotels not found') }}</h1>
        <p class="text-dark-gray">{{ tr('The selected group itinerary has no available hotels.') }}</p>
      </section>
      <div v-else v-for="city of cities" :key="city.locationCode">
        <HotelsCity :hotels="city.hotels" :name="city.locationName" />
      </div>
    </main>
    <Footer />
    <Transition>
      <BlockUI v-if="loading" />
    </Transition>
  </div>
</template>

<script>
import BlockUI from '@/components/tools/BlockUI.vue';
import Header from '@/components/hotels/Header.vue';
import HotelsCity from '@/components/hotels/HotelsCity.vue';
import Footer from '@/components/tools/Footer.vue';
import '@/assets/css/main.scss';

const api = window.api;

export default {
  name: 'SayGroupHotels',
  data() {
    return {
      loading: true,
      loadError: false,
    };
  },
  computed: {
    cities() {
      return this.$store.getters.cities;
    },
  },
  async mounted() {
    const params = {
      ...this.$route.query,
      name: this.$route.params.name,
    };

    api.get('/api/groups/itinerary_seller_db', params, null, (seller) => {
      if (seller) this.$store.commit('setSeller', seller);
    });

    try {
      const result = await api.get('/api/groups/itinerary_booking_hotels', params);
      if (result) {
        this.$store.commit('setBookingHotels', result);
        this.$store.commit('setNames', {
          values: [{ CATEGORY: 'PAX', MESSAGE_TEXT: result.pax_name }],
          isPCM: false,
        });
        this.$store.commit('setQuery', params);
        this.loadError = !result.hotels || result.hotels.length === 0;
      } else {
        this.loadError = true;
      }
    } catch (error) {
      this.loadError = true;
    } finally {
      this.loading = false;
    }
  },
  components: {
    BlockUI,
    Header,
    HotelsCity,
    Footer,
  },
  methods: {
    tr(key) {
      return this.$root.tr(key);
    },
  },
};
</script>
